module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-CondensedBlackItalic.a05d1f3.eot";